// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {"tag": "DEV 8fda6803c415000e7c9a72fa27d07db91946b39d"};
/* tslint:enable */
